import { DataLayer } from "./data-layer";

export namespace ResponsiveUtils {
    export const breakpoints = {
        xs: 0,
        xs1: 366,
        xs2: 480,
        sm: 768,
        sm2: 1024,
        md: 1280,
        // Laptop
        lg: 1680,
        // Desktop
        xl: 2200,
    } as const;

    export function getDataLayerResolution() {
        let resolution = "mobile";

        if (breakpointUp("lg")) {
            resolution = "big desktop";
        } else if (breakpointUp("md")) {
            resolution = "small desktop";
        } else if (breakpointUp("sm")) {
            resolution = "tablet";
        }

        return resolution;
    }

    export function logDataLayer() {
        DataLayer.push({ page: { responseDesignCategory: getDataLayerResolution() } });
    }

    export function breakpointUp(breakpointName: keyof typeof breakpoints) {
        return window.matchMedia(`(min-width: ${breakpoints[breakpointName]}px)`).matches;
    }

    export function breakpointDown(breakpointName: keyof typeof breakpoints) {
        return window.matchMedia(`(max-width: ${breakpoints[breakpointName] - 1}px)`).matches;
    }

    export function isMobile(): boolean {
        return ngLoader.isMobile();
    }

    export function isIpad13Up(): boolean {
        // detects iPads and (unfortunately) MacBooks with touch support (they don't exist yet)
        return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    }

    export function isIpad(): boolean {
        return /iPad/.test(navigator.userAgent) || isIpad13Up();
    }

    export function isInternetExplorer() {
        return document.body.classList.contains("internet-explorer");
    }

    export function isSafari() {
        return document.body.classList.contains("safari");
    }

    export function isIos() {
        return /iPhone|iPad/.test(navigator.userAgent) || isIpad();
    }

    export function isAndroid() {
        return /android|Android/.test(navigator.userAgent);
    }

    export function isAndroidFirefox() {
        return document.body.classList.contains("firefox-mobile") && isAndroid();
    }

    export function isTouchDevice() {
        return "ontouchstart" in window || navigator.maxTouchPoints;
    }

    export function isOnlyTouchDevice() {
        return isTouchDevice() && matchMedia("(hover: none)").matches;
    }

    export function isMovSupported() {
        return isIos() || isSafari();
    }
}
